const fetchFlightData = async (file) => {
    const response = await fetch(file);
    const data = await response.text();
    const flights = readFlightData(data);
    return flights;
};

const readFlightData = (data) => {
    const lines = data.split('\n');
    const flights = [];

    lines.forEach((line) => {
        const parts = line.split(';').map((part) => part.trim());
        if (parts[0] !== '') {
            let status = parts[4] ? parts[4]?.split(',') : [];
            flights.push({
                airline: parts[0],
                flightNumber: parts[1],
                time: parts[2],
                location: parts[3],
                status: status,
            });
        }
    });

    return flights;
};

const getAirline = (code) => {
    const airlines = {
        AA: 'American Airlines',
        BA: 'British Airways',
        DL: 'Delta Airlines',
        FR: 'Ryanair',
        LH: 'Lufthansa',
        UA: 'United Airlines',
    };

    return airlines[code] ?? code;
};

export { fetchFlightData, getAirline };
